import React from 'react'
import View from './view'

const VenueManage = ({ ...props }) => {
    return <View {...props} />
}

export default VenueManage
